import { render, staticRenderFns } from "./StudyLogin.vue?vue&type=template&id=1158a848&scoped=true&"
import script from "./StudyLogin.vue?vue&type=script&lang=js&"
export * from "./StudyLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1158a848",
  null
  
)

export default component.exports